import script from "./RequestArchives.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestArchives.vue?vue&type=script&setup=true&lang=js"

import "./RequestArchives.vue?vue&type=style&index=0&id=0ccd5e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccd5e08"]])

export default __exports__